import React from 'react';
import { Route } from 'react-router';
import Marketing from '../pages/Events/Marketing';

const App = () => {
	return (
		<Route path='/'>
			<Marketing />
		</Route>
	);
};

export default App;
